var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.22485,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#5E6073"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7172 26.7249C23.3776 26.7249 26.4736 22.1077 26.4736 18.1038C26.4736 17.9726 26.4736 17.8421 26.4646 17.7121C27.0669 17.2832 27.5868 16.7521 28 16.1438C27.4383 16.3888 26.8425 16.5495 26.2324 16.6205C26.8748 16.2418 27.3557 15.6462 27.5854 14.9446C26.9813 15.2975 26.3204 15.5462 25.6312 15.68C24.6772 14.6814 23.1614 14.4369 21.9337 15.0838C20.706 15.7307 20.0718 17.108 20.3866 18.4435C17.9121 18.3213 15.6067 17.1706 14.044 15.2778C13.2272 16.6622 13.6444 18.4333 14.9968 19.3225C14.507 19.3082 14.028 19.1781 13.6 18.9432C13.6 18.9556 13.6 18.9686 13.6 18.9816C13.6004 20.4239 14.6331 21.6662 16.069 21.9518C15.6159 22.0734 15.1405 22.0912 14.6794 22.0038C15.0826 23.238 16.2379 24.0836 17.5546 24.1079C16.4648 24.9512 15.1186 25.4089 13.7326 25.4075C13.4877 25.4071 13.2431 25.3925 13 25.3638C14.4074 26.253 16.0449 26.7247 17.7172 26.7225",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f30ec7074ff232d7be6c4b0fa049d794.svg";
export { ForwardRef as ReactComponent };